class FriendlyFractionNumeratorNodeView {

	constructor(node) {
		this.node = node
		this.dom = this.contentDOM = document.createElement("span")
		this.dom.classList.add("friendlyFraction-numerator")
		const textContent= this.node.textContent
		let empty=true
		if(textContent && textContent.length!==0){
			empty=false
		} 
		if(empty){
			this.dom.classList.add("friendlyFraction-numerator--empty")
		}
	}

	update(node) {
		if (node.type !== this.node.type) return false
		this.dom.classList=''
		this.dom.classList.add("friendlyFraction-numerator")
		const textContent= node.textContent
		let empty=true
		if(textContent && textContent.length!==0){
			empty=false
		} 
		if(empty){
			this.dom.classList.add("friendlyFraction-numerator--empty")
		}
		this.node=node
		return true
	}

}

export default FriendlyFractionNumeratorNodeView